var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appKelas,attrs:{"id":"app"},on:{"click":_vm.appClick}},[_c('router-view'),_c('Alert'),_c('AppLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }